import { addDays, daysBetween, fm, fr, minusMonths } from './dates';

// The "Compare with" ranges. Each one picks which completed cycles the
// averages, trends and heatmaps use — a filter on the server's cycles by start
// date, never a cycle rule of our own.

export const RANGE_KEYS = ['prev', '3m', '6m', '1y'];

const RANGES = {
  prev: { label: 'Previous cycle', long: 'Previous cycle', months: 0 },
  '3m': { label: '3 months', long: 'Last 3 months', months: 3 },
  '6m': { label: '6 months', long: 'Last 6 months', months: 6 },
  '1y': { label: '1 year', long: 'Last 12 months', months: 12 },
};

/**
 * @returns {{ key: string, comp: import('./cycleModel').Cycle[], rl: string, rnote: string }}
 *   `comp` = the completed cycles in range (at least the latest one, when any).
 */
export function compareContext(ctx, key) {
  const { months, long } = RANGES[key];
  const done = ctx.done;
  const from = months ? minusMonths(ctx.today, months) : null;
  const inRange = months ? done.filter((c) => c.start >= from) : done.slice(-1);
  const comp = inRange.length ? inRange : done.slice(-1);
  let rnote;
  if (!comp.length) rnote = 'No completed cycle yet.';
  else if (key === 'prev') {
    const p = ctx.prev;
    rnote = `Current cycle compared with cycle ${p.n} (${fr(p.start, addDays(p.nextStart, -1))}).`;
  } else if (ctx.cycles[0].start > from) {
    // README gap G10: the history is shorter than the range.
    const m = Math.max(1, Math.round(daysBetween(ctx.cycles[0].start, ctx.today) / 30.4));
    rnote = `Only ${m} ${m === 1 ? 'month' : 'months'} of history recorded — all ${comp.length} completed ${comp.length === 1 ? 'cycle' : 'cycles'} shown.`;
  } else {
    rnote = `${comp.length} completed ${comp.length === 1 ? 'cycle' : 'cycles'} since ${fm(comp[0].start)}.`;
  }
  return { key, comp, rl: long, rnote };
}

/** The switch's options, with the active one marked. */
export const rangeOptions = (active) =>
  RANGE_KEYS.map((key) => ({ key, label: RANGES[key].label, active: key === active }));
